import { useEffect, useState } from 'react';

/** Close transition duration — keep in sync with panel CSS (transform/opacity). */
export const SLIDE_PANEL_CLOSE_MS = 300;
const OPEN_READY_MS = 10;

/**
 * Mount/unmount timing for slide-in panels (catalog drawers, inventory panel).
 * Keeps the shell mounted through the close animation, then unmounts.
 */
export function useSlidePanelAnimation(isOpen: boolean): {
  shouldRender: boolean;
  isReady: boolean;
  panelClassName: 'open' | 'closed';
} {
  const [isReady, setIsReady] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      const timer = setTimeout(() => {
        setIsReady(true);
      }, OPEN_READY_MS);
      return () => clearTimeout(timer);
    }

    setIsReady(false);
    const timer = setTimeout(() => {
      setShouldRender(false);
    }, SLIDE_PANEL_CLOSE_MS);
    return () => clearTimeout(timer);
  }, [isOpen]);

  return {
    shouldRender,
    isReady,
    panelClassName: isOpen && isReady ? 'open' : 'closed',
  };
}
